import React, { useRef, useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import FileService from '../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import { useTranslation } from 'react-i18next';
import Constants from '../constants/Constants';
import { Dialog } from 'primereact/dialog';
import AuthService from '../security/AuthService';
import { useParams } from 'react-router-dom';
import CustomAddArtworks from './CustomAddArtworks';

const CustomGaleria = (props) => {
    const { t } = useTranslation();

    console.log("CustomGaleria", props)

    const [activeIndex, setActiveIndex] = useState(0);

    const galleriaRef = useRef(null);
    const [showInfo, setShowInfo] = useState(false);
    let { profileId, userType } = useParams();
    const [addArtworkVisible, setAddArtworkVisible] = useState(false);


    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    const itemTemplate2 = (item) => {
        return <div className='flex justify-content-center w-12 align-items-center flex-column'>
            <img src={FileService.inquireFilePath(item.file)} alt={item.name} style={{ maxWidth: 500, maxHeight: 600, display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />
            <div className={'text-3xl  font-700-regular pt-3 font-white'}>
                {item.name}

            </div>
            <div className=' font-400-regular pt-3 font-white'>
                {item.descr}

            </div>
        </div>;
    }

    const itemTemplate = (item) => {
        return (

            <div className="grid align-items-end  justify-content-center w-12" style={{}}>

                <div className='text-center col-12 md:col-7 pr-5 ' >
                    <div className='exhibition-images' style={{
                        backgroundImage: `url(${FileService.inquireFilePath(item.file)})`,
                    }}
                    />
                </div>
                <div className="col-12 md:col-5 align-items-start pr-5 " >

                    <div id="content_info_div">
                        <span className="block text-6xl  mb-1" style={{ color: '#F7F7F7' }}>
                            {item.name}
                        </span>
                        <span className="block text-1xl  mb-1 " style={{ color: '#F7F7F7' }}>
                            {item.descr}
                        </span>

                        <div className='  mt-2  ' style={{ color: '#F7F7F7' }}>
                            <Button icon="fa-regular fa-heart" className={item.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"} disabled={!AuthService.isLoggedIn()}
                                onClick={() => {
                                    if (item.favoriteId)
                                        props.onRemoveFavorite(item.favoriteId, item);
                                    else
                                        props.onAddFavorite(Constants.entityNames.artwork, item)
                                }}
                            />
                            <Button className="p-button-rounded p-button-light mr-2 mb-2" label={item.ownerName} disabled
                            />
                            <Button className="p-button-rounded p-button-light mr-2 mb-2" label={t("technical_info")}
                                onClick={(e) => {
                                    setShowInfo(true);
                                    //opInfo.current.toggle(e);

                                    console.log("technical_info")
                                }}
                            />
                             { profileId == AuthService.getUserId() &&
                                <Button icon="fas fa-file-pen" className="p-button-rounded p-button-light mr-2 mb-2"
                                    onClick={() => { onEditArtwork(item) }}
                                />
                            }
                            { profileId == AuthService.getUserId() &&
                                <Button icon="fas fa-trash" className="p-button-rounded p-button-light mr-2 mb-2"
                                    onClick={() => { props.onRemoveArtwork(item) }}
                                />
                            }
                            
                        </div>
                        {artworkInfoPanel(item)}
                    </div>
                </div>

            </div>

        );
    }

    const artworkInfoPanel = (item) => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={showInfo}
                onHide={() => setShowInfo(false)} className={'artinfo-dialog'} headerClassName='artinfo-dialog-header'
                headerStyle={{ alignSelf: 'flex-end' }}
                contentClassName='artinfo-dialog-content'
            >
                <div className="grid align-items-end  justify-content-center " >


                    <div className='text-center col-12 md:col-7 pr-5 ' >
                    </div>
                    <div className="col-12 md:col-5 align-items-start pr-8" >

                        <div>
                            <span className="block text-6xl  mb-1" style={{ color: '#000000' }}>
                                {item.name}
                            </span>
                            <span className="block text-1xl  mb-1 " style={{ color: '#000000' }}>
                                {item.descr}
                            </span>

                            <div className='  mt-2  ' style={{ color: '#000000' }}>
                                <Button icon="fa-regular fa-heart" className={item.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"} disabled
                                />
                                <Button className="p-button-rounded p-button-light mr-2 mb-2" label={item.ownerName} disabled
                                />
                                <Button className="p-button-rounded p-button-dark mr-2 mb-2" label={t("technical_info")} disabled
                                />
                            </div>
                            <div className="col-12 md:col-12 flex justify-content-between align-items-start text-left " >
                                <div className="register-content w-12 " >
                                    <div className='flex justify-content-between w-12 align-items-center flex-column p-3' style={{ minHeight: 320 }} >
                                        <div className='grid w-12'>
                                            {item.artYear &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_createdate") + ": " + item.artYear}
                                                </div>
                                            }
                                            {item.artType &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_" + item.artType)}
                                                </div>
                                            }
                                            {item.artWidth && item.artHeight &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_measure") + ": " + item.artWidth}x{item.artHeight}  {t("global_artwork_" + item.measureUnit)}
                                                </div>
                                            }
                                            {item.material &&
                                                <div className="col-12 md:col-6" style={{
                                                    wordWrap: 'break-word',
                                                    paddingBottom: 5,
                                                }}>
                                                    {t("global_artwork_material") + ": " + item.material}
                                                </div>
                                            }
                                        </div>
                                        <div className='flex justify-content-between w-12 align-items-center flex-row'

                                        > </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>


            </Dialog >

        )


    }

    const thumbnailTemplate = (item) => {
        return <img src={FileService.inquireFilePath(item.file)} alt={item.name} style={{ display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />;
    }

    const selectedArtworks = (index) => {
        setActiveIndex(index);
        galleriaRef.current.show()
    }

    const onEditArtwork = (artwork) => {
        //galleriaRef.current.show()
     //   setActiveIndex(null);
        
        setAddArtworkVisible(true);
       

    }
    const renderArtworksLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={addArtworkVisible} position={'top'} onHide={() => setAddArtworkVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomAddArtworks {...props}  setDialogVisible={setAddArtworkVisible} artwork={props.artworks[activeIndex]} 
                ></CustomAddArtworks>




            </Dialog>

        )


    }

    return (
        <div >
            <Galleria ref={galleriaRef} value={props.artworks} responsiveOptions={responsiveOptions} numVisible={7} style={{ width: '80%' }}
                activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />

            <div className="grid responsive-grid" >
                {
                    props.artworks && props.artworks.map((image, index) => {
                        let imgEl =
                            <div className='art-images' style={{
                                backgroundImage: `url(${FileService.inquireFilePath(image.file)})`,
                            }}
                                onClick={
                                    () => {
                                        //  props.onAction(0);

                                        props.hasAction ? props.onAction(props.artworks[index]) : selectedArtworks(index);

                                    }
                                } />

                        return (
                            <div className='m-2 mb-6' key={index}>
                                <div className='text-center' style={{ borderRadius: 20, width: 275, height: 225 }}>
                                    {imgEl}
                                </div>
                                <div className='text-2xl  font-400-regular pt-3 ' style={{
                                    ...props.labelStyle
                                }}>
                                    {image.name}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    props.RenderAddPanel && props.RenderAddPanel()
                }

            </div>
            {
                renderArtworksLayer()
            }
        </div>
    );
};

export default CustomGaleria;
